import { Wall } from "../views/kitchen/KitchenService";

export class History {
    items: HistoryItem[] = [];
}
export interface HistoryItem {
    item: Wall;
}